import * as React from "react";
import { Button, styled } from "@mui/material";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { ReactComponent as KahunSvgLogo } from "../assets/kahun_new_logo_black.svg";
import { useCallback } from "react";
//region [[ Styles ]]

const KahunNavigationLogoView = styled(Button)(
  ({ hidebackground }: { hidebackground: number }) => ({
    background: hidebackground ? "trasnparent" : KahunColorMap.Primary,
    display: "flex",
    alignItems: "center",
    position: "sticky",
    top: 0,
    borderRadius: 0,
    justifyContent: "unset",
  }),
);

type KahunLogoProps = {
  small: "true" | "false";
};

const KahunLogo = styled(KahunSvgLogo)((props: KahunLogoProps) => ({
  width: props.small === "true" ? "133px" : "167px",
  height: (props.small === "true" ? "40px" : "51px"),
  margin: "33px 0px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface KahunNavigationLogoProps {
  className?: string;
  small?: boolean;
  hideBackground?: boolean;
  disabled?: boolean;
  preventCLick?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const KahunNavigationLogo = ({
  disabled,
  preventCLick,
  ...props
}: KahunNavigationLogoProps) => {
  const handleLogoClicked = useCallback(() => {
    if (!disabled && !preventCLick)
      window.location.href = "https://www.kahun.com";
  }, [disabled, preventCLick]);

  return (
    <KahunNavigationLogoView
      className={props.className}
      disabled={disabled}
      onClick={handleLogoClicked}
      hidebackground={props.hideBackground ? 1 : 0}
    >
      <KahunLogo small={props.small ? "true" : "false"} />
    </KahunNavigationLogoView>
  );
};
